import { Filter } from "../../../openApiClients/generated/EngineeringUK.Sites";

export function getFilteredListOfFilters(filters: Filter[], allowedFilters: string[]) {
  return filters.filter(x => (x.options?.length ?? 0) > 0 && ((allowedFilters?.length ?? 0) === 0 || allowedFilters.filter(filter => filter == x.id).length > 0)) ?? [];
}
